'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _jsxFileName = 'src/reviews.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _reactSwipeableViews = require('react-swipeable-views');
var _reactSwipeableViews2 = _interopRequireDefault(_reactSwipeableViews);
var _reactSwipeableViewsUtils = require('react-swipeable-views-utils');
var _icon = require('@marmalade/icon');
var _icon2 = _interopRequireDefault(_icon);
var _reduxWindow = require('redux-window');
var _reviewRenderer = require('./review-renderer');
var _reviewRenderer2 = _interopRequireDefault(_reviewRenderer);
var _messageBase = require('./message-base');
var _messageBase2 = _interopRequireDefault(_messageBase);
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var arrowStyles = function arrowStyles(_ref) {
  var theme = _ref.theme,
    small = _ref.small;
  return {
    fontSize: small ? '2rem' : '3rem',
    zIndex: 100,
    color: theme.colorPrimary,
    margin: small ? 0 : undefined,
    flexShrink: 0,
    cursor: 'pointer'
  };
};
var Arrow = (0, _glamorous2.default)(_icon2.default)(arrowStyles);
var dotStyles = function dotStyles(_ref2) {
  var theme = _ref2.theme,
    active = _ref2.active;
  return {
    cursor: 'pointer',
    width: '10px',
    height: '10px',
    margin: '5px',
    backgroundColor: active ? theme.colorPrimary : theme.colorGrey,
    borderRadius: '50%'
  };
};
var VirtualizeSwipeableViews = (0, _reactSwipeableViewsUtils.virtualize)(_reactSwipeableViews2.default);
var Reviews = function (_Component) {
  _inherits(Reviews, _Component);
  function Reviews() {
    var _ref3;
    var _temp, _this, _ret;
    _classCallCheck(this, Reviews);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Reviews.__proto__ || Object.getPrototypeOf(Reviews)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      index: 0,
      data: [],
      stars: 5,
      total: 0,
      loaded: false,
      error: false,
      highestRatingScore: 5,
      score: 5,
      ratingString: ''
    }, _this.goBack = function () {
      _this.setState(function (state) {
        return {
          index: state.index - 1
        };
      });
    }, _this.goForward = function () {
      _this.setState({
        index: _this.state.index + 1
      });
    }, _this.handleDotClick = function (position) {
      var _this$state = _this.state,
        index = _this$state.index,
        data = _this$state.data;
      _this.setState({
        index: index % data.length < 0 ? index - (index % data.length + data.length) + position : index - index % data.length + position
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Reviews, [{
    key: 'dot',
    value: function dot(position) {
      var _this2 = this;
      var _state = this.state,
        index = _state.index,
        data = _state.data;
      var Dot = (0, _glamorous2.default)('div')(dotStyles);
      return _react2.default.createElement(Dot, {
        key: position,
        role: 'button',
        tabIndex: 0,
        active: index % data.length < 0 ? index % data.length + data.length === position : index % data.length === position,
        onClick: function onClick() {
          return _this2.handleDotClick(position);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 78
        },
        __self: this
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;
      var reviewsRequest = _axios2.default.post(process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/trustpilot/reviews', {
        quantity: 10,
        stars: 5
      });
      var scoreRequest = _axios2.default.get(process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/trustpilot-score');
      Promise.all([reviewsRequest, scoreRequest]).then(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          reviewsResponse = _ref5[0],
          scoreResponse = _ref5[1];
        _this3.setState(Object.assign({}, scoreResponse.data.data, {
          data: reviewsResponse.data.data.map(function (_ref6) {
            var stars = _ref6.stars,
              title = _ref6.title,
              content = _ref6.content;
            return {
              title: title,
              body: content,
              rating: ~~stars
            };
          }),
          loaded: true
        }));
      }).catch(function (err) {
        console.error(err);
        _this3.setState({
          error: true
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;
      if (this.state.error) {
        return _react2.default.createElement('a', {
          target: '_blank',
          href: 'https://www.trustpilot.com/review/wearemarmalade.co.uk',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 120
          },
          __self: this
        }, 'See our reviews on Trust Pilot.');
      }
      var mobile = this.props.mobile;
      if (this.state.error) {
        return _react2.default.createElement('a', {
          href: 'https://www.trustpilot.com/review/wearemarmalade.co.uk',
          rel: 'nofollow noopener noreferrer',
          target: '_blank',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 130
          },
          __self: this
        }, 'See our reviews on independant rating site Trust Pilot');
      }
      if (!this.state.loaded) {
        return _react2.default.createElement(_loading2.default, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 141
          },
          __self: this
        });
      }
      return _react2.default.createElement(_glamorous2.default.Div, {
        textAlign: 'center',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 145
        },
        __self: this
      }, _react2.default.createElement(_icon.LargePrimaryIcon, {
        type: 'profile',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 146
        },
        __self: this
      }), _react2.default.createElement('h2', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 147
        },
        __self: this
      }, 'What our customers say'), _react2.default.createElement(_glamorous2.default.Div, {
        display: 'flex',
        alignItems: 'center',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 148
        },
        __self: this
      }, !mobile && _react2.default.createElement(Arrow, {
        type: 'arrow-left',
        onClick: this.goBack,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 149
        },
        __self: this
      }), _react2.default.createElement(VirtualizeSwipeableViews, {
        index: this.state.index,
        onChangeIndex: function onChangeIndex(index) {
          return _this4.setState({
            index: index
          });
        },
        slideRenderer: (0, _reviewRenderer2.default)(this.state.data),
        overscanSlideBefore: Math.ceil(this.state.data.length / 2) - 1,
        overscanSlideAfter: Math.floor(this.state.data.length / 2),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 150
        },
        __self: this
      }), !mobile && _react2.default.createElement(Arrow, {
        type: 'arrow-right',
        onClick: this.goForward,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157
        },
        __self: this
      })), _react2.default.createElement(_glamorous2.default.Div, {
        display: 'flex',
        justifyContent: !mobile ? 'center' : 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 159
        },
        __self: this
      }, mobile && _react2.default.createElement(Arrow, {
        type: 'arrow-left',
        onClick: this.goBack,
        small: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 165
        },
        __self: this
      }), _react2.default.createElement(_glamorous2.default.Div, {
        display: 'flex',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166
        },
        __self: this
      }, this.state.data.map(function (_, i) {
        return _this4.dot(i);
      })), mobile && _react2.default.createElement(Arrow, {
        type: 'arrow-right',
        onClick: this.goForward,
        small: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 167
        },
        __self: this
      })), _react2.default.createElement(_messageBase2.default, {
        darkLogo: true,
        smallImage: true,
        stars: this.state.stars,
        message: _react2.default.createElement(_react.Fragment, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 174
          },
          __self: this
        }, _react2.default.createElement('strong', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 175
          },
          __self: this
        }, this.state.ratingString), ' rating on independent review site', ' ', _react2.default.createElement('a', {
          href: 'https://www.trustpilot.com/review/wearemarmalade.co.uk',
          rel: 'nofollow noopener noreferrer',
          target: '_blank',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 176
          },
          __self: this
        }, 'Trust Pilot')),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 169
        },
        __self: this
      }));
    }
  }]);
  return Reviews;
}(_react.Component);
Reviews.propTypes = {
  mobile: _propTypes.bool.isRequired
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    mobile: (0, _reduxWindow.getWidth)(state) <= 600
  };
})(Reviews);